module.exports = __webpack_public_path__ + "plat/static/img/login_bg_overseas.f41ccd9a.jpg";